/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface BlogCreateInput { 
    archived?: boolean;
    blogCategory?: string;
    blogId: number;
    content?: string;
    createdAt?: string;
    date?: string;
    description?: string;
    featured: boolean;
    id?: string;
    image?: string;
    locked?: boolean;
    path: string;
    pdf?: string;
    published?: boolean;
    readOnly?: boolean;
    title: string;
    updatedAt?: string;
    version?: number;
    youtubeEmbedCode?: string;
}
